import React from 'react';
import styled from 'styled-components';

import { Box } from '../../../Box';
import { EntitySymbol } from '../../../EntitySymbol';
import { Truncate } from '../../../Truncate';

type DrawerTitleProps = {
  title: string | React.ReactNode;
  titleIconVariant?: React.ComponentProps<typeof EntitySymbol>['variant'];
  titleIconDraft?: boolean;
  maxTitleLines?: number;
};

const EntitySymbolWrapper = styled(Box)`
  flex-shrink: 0;
  padding-top: 2px;
`;

export const DrawerTitle = ({
  title,
  titleIconVariant,
  titleIconDraft,
  maxTitleLines,
}: DrawerTitleProps) => {
  return (
    <Box display="flex" alignItems="start" flexGap="16px">
      {titleIconVariant && (
        <EntitySymbolWrapper>
          <EntitySymbol
            variant={titleIconVariant}
            draft={titleIconDraft}
            size="m"
          />
        </EntitySymbolWrapper>
      )}
      {typeof title === 'string' ? (
        // A Drawer is pinned to the right edge of the viewport, its actions
        // sit above the title and its content below, so the free space for the
        // tooltip is beside it. Past that width it gets shifted back over the
        // Drawer.
        <Truncate
          text={title}
          maxLines={maxTitleLines}
          tooltipPlacement="left"
          tooltipMaxWidth="400px"
          textProps={{ fontSize: 24, fontWeight: 'bold' }}
        />
      ) : (
        title
      )}
    </Box>
  );
};
